<template>
  <div id="sidebar"
    :class="{'column sidebar is-narrow custom-scrollbar' : true, collapsed: collapsed}"
  >
    <!-- <div class="brand">
      UPDIVISION
    </div> -->
    <div class="user">
      <div class="columns is-gapless is-mobile">
        <div class="column is-narrow">
          <img class="user-image" src="@/assets/img/icons/msapplication-icon-144x144.png" alt="">
        </div>
        <div class="column user-actions">
          <p class="user-actions__name">John Smith</p>
          <p class="user-actions__status"><i class="fas fa-circle-notch"></i> Online</p>
        </div>
      </div>
    </div>
    <aside class="menu">
      <ul class="menu-list">
        <li :class="{'is-active' : $route.name == 'dashboard'}">
          <router-link class="menu-item" :to="{name:'dashboard'}">
            <span class="icon is-medium">
              <i class="fas fa-tachometer-alt"></i>
            </span>
            <span class="item-list-name">Dashboard</span>
          </router-link>
        </li>
        <li :class="{'is-active' : $route.name == 'buttons'}">
          <router-link class="menu-item" :to="{name:'buttons'}">
            <span class="icon is-medium">
              <i class="fas fa-arrow-alt-circle-down"></i>
            </span>
            <span class="item-list-name">Buttons</span>
          </router-link>
        </li>
        <li :class="{'is-active': 'ui-elements' == $route.matched[0].name
        || expandedItem == 'ui-elements' }">
          <div @click="toggleSubMenu('ui-elements')" class="menu-item">
            <span class="icon is-medium">
              <i class="fas fa-file"></i>
            </span>
            <span class="item-list-name">UI Elements</span>
            <span class="icon is-right">
              <i class="fas fa-angle-left"></i>
            </span>
          </div>
          <ul :class="{'is-opened' : 'ui-elements' == $route.matched[0].name
          || expandedItem == 'ui-elements'}">
            <li :class="{'is-active' : $route.name == 'typography'}">
              <router-link :to="{name: 'typography'}">Typography</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'helpers'}">
              <router-link :to="{name: 'helpers'}">Helpers</router-link>
            </li>
          </ul>
        </li>
        <li :class="{'is-active' : $route.name == 'galleries'}">
          <router-link class="menu-item" :to="{name:'galleries'}">
            <span class="icon is-medium">
              <i class="fas fa-pallet"></i>
            </span>
            <span class="item-list-name">Galleries</span>
          </router-link>
        </li>
        <li :class="{'is-active' : $route.name == 'widgets'}">
          <router-link class="menu-item" :to="{name: 'widgets'}">
            <span class="icon is-medium">
              <i class="fas fa-wrench"></i>
            </span>
            <span class="item-list-name">Widgets</span>
          </router-link>
        </li>
        <!-- <li :class="{'is-active' : $route.name == 'file-page-uploads'}">
          <router-link class="menu-item" :to="{name:'file-page-uploads'}">
            <span class="icon is-medium">
              <i class="fas fa-upload"></i>
            </span>
            <span class="item-list-name">File Uploads</span>
          </router-link>
        </li> -->
        <li :class="{'is-active' : $route.name == 'grids'}">
          <router-link class="menu-item" :to="{name:'grids'}">
            <span class="icon is-medium">
              <i class="fas fa-upload"></i>
            </span>
            <span class="item-list-name">Grids</span>
          </router-link>
        </li>
        <li
          :class="{'is-active': $route.matched[0].name == 'form-elements'
          || expandedItem == 'form-elements'}"
        >
          <div @click="toggleSubMenu('form-elements')" class="menu-item">
            <span class="icon is-medium">
              <i class="fas fa-file"></i>
            </span>
            <span class="item-list-name">Form elements</span>
            <span class="icon is-right">
              <i class="fas fa-angle-left"></i>
            </span>
          </div>
          <ul :class="{'is-opened' : 'form-elements' == $route.matched[0].name
          || expandedItem == 'form-elements'}">
            <li :class="{'is-active' : $route.name == 'generals'}">
              <router-link :to="{name: 'generals'}">General</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'advanced'}">
              <router-link :to="{name: 'advanced'}">Advanced</router-link>
            </li>
          </ul>
        </li>
        <li :class="{'is-active': $route.matched[0].name == 'misc'
        || expandedItem == 'misc'}">
          <div class="menu-item" @click="toggleSubMenu('misc')">
            <span class="icon is-medium">
              <i class="fas fa-cogs"></i>
            </span>
            <span class="item-list-name">Misc</span>
            <span class="icon is-right">
              <i class="fas fa-angle-left"></i>
            </span>
          </div>
          <ul :class="{'is-opened' : 'misc' == $route.matched[0].name
          || expandedItem == 'misc'}">
            <li :class="{'is-active' : $route.name == 'notifications'}">
              <router-link :to="{name: 'notifications'}">Notifications</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'spinner'}">
              <router-link :to="{name: 'spinner'}">Spinner</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'list'}">
              <router-link :to="{name: 'list'}">Lists</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'maps'}">
              <router-link :to="{name: 'maps'}">Maps</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'login'}">
              <router-link :to="{name: 'login'}">Login</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'lock'}">
              <router-link :to="{name: 'lock'}">Lock</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'poll'}">
              <router-link :to="{name: 'poll'}">Poll</router-link>
            </li>
          </ul>
        </li>
        <li :class="{'is-active': $route.matched[0].name == 'app-views'
        || expandedItem == 'app-views'}">
          <div class="menu-item" @click="toggleSubMenu('app-views')">
            <span class="icon is-medium">
              <i class="fas fa-eye"></i>
            </span>
            <span class="item-list-name">App views</span>
            <span class="icon is-right">
              <i class="fas fa-angle-left"></i>
            </span>
          </div>
          <ul :class="{'is-opened' : 'app-views' == $route.matched[0].name
          || expandedItem == 'app-views'}">
            <li :class="{'is-active' : $route.name == 'contacts'}">
              <router-link :to="{name: 'contacts'}">Contacts</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'article'}">
              <router-link :to="{name: 'article'}">Article</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'blog'}">
              <router-link :to="{name: 'blog'}">Blog</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'profile'}">
              <router-link :to="{name: 'profile'}">Profile</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'calendar'}">
              <router-link :to="{name: 'calendar'}">Calendar</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'errors'}">
              <router-link :to="{name: 'errors'}">Errors</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'contact-us'}">
              <router-link :to="{name: 'contact-us'}">Contact us</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'pricing'}">
              <router-link :to="{name: 'pricing'}">Pricing</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'faq'}">
              <router-link :to="{name: 'faq'}">FAQ</router-link>
            </li>
          </ul>
        </li>

        <li
          :class="{
            'is-active': $route.matched[0].name == 'chart-components'
            || expandedItem == 'chart-components'
          }"
        >
          <div class="menu-item" @click="toggleSubMenu('chart-components')">
            <span class="icon is-medium">
              <i class="fas fa-chart-pie"></i>
            </span>
            <span class="item-list-name">Chart components</span>
            <span class="icon is-right">
              <i class="fas fa-angle-left"></i>
            </span>
          </div>
          <ul :class="{'is-opened' : 'chart-components' == $route.matched[0].name
          || expandedItem == 'chart-components'}">
            <li :class="{'is-active' : $route.name == 'vuecharts'}">
              <router-link :to="{name: 'vuecharts'}">VueCharts</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'chartkick'}">
              <router-link :to="{name: 'chartkick'}">Chartkick</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'chartjs'}">
              <router-link :to="{name: 'chartjs'}">Chartjs</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'highcharts'}">
              <router-link :to="{name: 'highcharts'}">Highcharts</router-link>
            </li>
          </ul>
        </li>

        <li :class="{'is-active': $route.matched[0].name == 'tables'
        || expandedItem == 'tables'}">
          <div class="menu-item" @click="toggleSubMenu('tables')">
            <span class="icon is-medium">
              <i class="fas fa-table"></i>
            </span>
            <span class="item-list-name">Tables</span>
            <span class="icon is-right">
              <i class="fas fa-angle-left"></i>
            </span>
          </div>
          <ul :class="{'is-opened' : 'tables' == $route.matched[0].name
          || expandedItem == 'tables'}">
            <li :class="{'is-active' : $route.name == 'handson-tables'}">
              <router-link :to="{name: 'handson-tables'}">Handson Tables</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'buefy-tables'}">
              <router-link :to="{name: 'buefy-tables'}">Buefy Tables</router-link>
            </li>
            <li :class="{'is-active' : $route.name == 'vue-good-tables'}">
              <router-link :to="{name: 'vue-good-tables'}">Vue Good Tables</router-link>
            </li>
          </ul>
        </li>
        <li :class="{'is-active' : $route.name == 'animations'}">
          <router-link class="menu-item" :to="{name:'animations'}">
            <span class="icon is-medium">
              <i class="fas fa-magic"></i>
            </span>
            <span class="item-list-name">Animations</span>
          </router-link>
        </li>
      </ul>
    </aside>
  </div>
</template>

<script>
import bus from './../../bus';

export default {
  data() {
    return {
      isOpened: false,
      collapsed: true,
      expandedItem: undefined,
      xDown: null,
      yDown: null,
      swipeOffsetX: 40,
      swipeOffsetY: 80,
      leftOffset: 60,
    };
  },
  methods: {
    toggleSubMenu(name) {
      if (this.expandedItem === name) {
        this.expandedItem = undefined;
      } else {
        this.expandedItem = name;
      }
    },
    handleTouchStart(evt) {
      this.xDown = evt.touches[0].clientX;
      this.yDown = evt.touches[0].clientY;
    },
    handleTouchEnd(evt) {
      if (!this.xDown) {
        return;
      }
      const xUp = evt.changedTouches[0].clientX;
      const yUp = evt.changedTouches[0].clientY;
      const xDiff = this.xDown - xUp;
      const yDiff = this.yDown - yUp;
      if (Math.abs(yDiff) < this.swipeOffsetY && this.getBrowserWidth() < 1025) {
        if (xDiff > this.swipeOffsetX) {
          // swipe from right to left
          bus.$emit('closeSidebar');
        } else if (xDiff < this.swipeOffsetX) {
          // swipe from left to right
          if (this.xDown < this.leftOffset) {
            bus.$emit('openSidebar');
          }
        }
        /* reset value */
        this.xDown = null;
        this.yDown = null;
      }
    },
    getBrowserWidth() {
      return Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth,
      );
    },
  },
  mounted() {
    bus.$on('toggleSidebar', () => {
      this.collapsed = !this.collapsed;
      if (this.getBrowserWidth() > 1024) {
        const sidebar = document.getElementById('sidebar');
        const mainContent = document.getElementById('main-content');
        if (sidebar.offsetWidth < 300) {
          mainContent.style.maxWidth = 'calc(100vw - 300px)';
        } else {
          mainContent.style.maxWidth = 'calc(100vw - 64px)';
        }
      }
    });
    bus.$on('resetExpandedItem', () => {
      if (this.$route.matched.length === 1) {
        this.expandedItem = undefined;
      }
    });
    bus.$on('closeSidebar', () => {
      this.collapsed = true;
    });
    bus.$on('openSidebar', () => {
      this.collapsed = false;
    });
    // Sidebar touch events
    document.addEventListener('touchstart', this.handleTouchStart, false);
    document.addEventListener('touchend', this.handleTouchEnd, false);
  },
  destroyed() {
    document.removeEventListener('touchstart', this.handleTouchStart, false);
    document.removeEventListener('touchend', this.handleTouchEnd, false);
  },
};
</script>
